<script>
import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      formData: {
        dp_kode: "",
        dp_name: "",
        dp_id_pohon_profesi: null,
        dp_id: null,
      },
      dahanProfesiOption: [],
    };
  },
  props: ["typeTrans", "dataProfesi"],
  watch: {
    dataProfesi: function (newVal) {
      if (newVal == null) {
        this.formData = {
          dp_kode: "",
          dp_name: "",
          dp_id_pohon_profesi: null,
          dp_id: null,
        };
      } else {
        this.formData = {
          dp_kode: newVal.dp_kode,
          dp_name: newVal.dp_name,
          dp_id_pohon_profesi: newVal.dp_id_pohon_profesi,
          dp_id: newVal.dp_id,
        };
      }
    },
  },
  emits: ["submitForm"],
  methods: {
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      let payload = { ...this.formData };
      const url =
        this.typeTrans == "add"
          ? "master/dahan-profesi"
          : `master/dahan-profesi/${this.formData.dp_id}`;
      const method = this.typeTrans == "add" ? "post" : "put";
      const config = {
        method: method,
        url: process.env.VUE_APP_BACKEND_URL_VERSION + url,
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
        },
      };
      await axios(config)
        .then((response) => {
          console.log({ response });
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            console.log({ result });
            Swal.close();
            this.$emit("submitForm");
          });
        })
        .catch((error) => {
          console.log({ error });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.data,
          });
        });
    },
    validateForm() {
      if (
        this.formData.dp_kode === "" ||
        this.formData.dp_name === "" ||
        !this.formData.dp_id_pohon_profesi
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Silahkan Lengkapi Data",
        });

        return false;
      }

      return true; // Form is valid
    },
    async searchDahanProfesi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getPohonProfesi(search, loading);
      }
    },
    async getPohonProfesi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/pohon-profesi/all",
          {
            params: {
              search: search,
              limit: 20,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.dahanProfesiOption = response.data.data;
          if (loading) loading(false);
        });
    },
  },
  mounted() {
    this.getPohonProfesi();
    this.filterDahanProfesi = _.debounce(
      this.searchDahanProfesi.bind(this),
      500
    );
  },
};
</script>

<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="form-group mb-3">
        <label for="kodeProfesi" class="form-label">Kode Dahan Profesi</label>
        <input
          type="text"
          v-model="formData.dp_kode"
          class="form-control"
          id="kodeProfesi"
          placeholder="Kode Dahan Profesi..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="namaProfesi" class="form-label">Nama Dahan Profesi</label>
        <input
          type="text"
          v-model="formData.dp_name"
          class="form-control"
          id="namaProfesi"
          placeholder="Nama Dahan Profesi..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="Keterangan" class="form-label">Pohon Profesi</label>
        <v-select
          id="parent_menu"
          class="style-chooser"
          :options="dahanProfesiOption"
          :reduce="(item) => item.ph_id"
          label="ph_name"
          v-model="formData.dp_id_pohon_profesi"
          placeholder="Pohon Profesi"
          @search="filterDahanProfesi"
        />
      </div>
      <div class="form-group float-end">
        <button class="btn btn-primary">
          <i class="fa fa-save"></i> Simpan
        </button>
      </div>
    </form>
  </div>
</template>
